export const maxFavouriteId = 50000;
export const maxFavoriteIdForOwner = 40000;

export const favouriteAdminTranslation = {

  // section title
  manage_favourites_title: 9091,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_favourite: 9122,
  search_folder_path: 9215,

  // messages
  no_access_to_favourite_admin: 9124,
  favourite_deleted: 9117,
  schedule_deleted: 9145,

  // list item
  disabled: 9119,
  disabled_removed: 9170,
  disabled_tooltip: 9177,
  shared: 9092,

  // confirmation
  delete_confirmation: 9109,
  delete_favourite_title: 9118,
  delete_favourite_button: 9363,
  clear_parent: 9214,
  mass_update_of: 9237,
  change_owner: 9098,
  change_owner_description: 9155,
  change_owner_confirmation_description: 9157,
  replace_with_owners: 9840,
  change_user_groups: 9169,
  change_user_groups_done: 9176,
  change_user_groups_confirmation_description: 9174,
  change_users: 9147,
  change_users_confirmation_description: 9194,
  change_users_done: 9176,
  apply_on_descendants: 9205,
  owners_apply_on_descendants_modal_title: 9921,
  owners_apply_on_descendants_modal_add_description: 9922,
  owners_apply_on_descendants_modal_remove_description: 9923,
  owners_apply_on_descendants_modal_sub_description: 9919,
  owners_apply_on_descendants_modal_checkbox: 9920,
  save: 9121,
  cancel: 9120,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  favourite_updated: 9128,
  favourite_validation_error: 8206,
  saving_favourite: 9129,
  deleting_favourite: 9130,
  fields_are_filled_out_incorrectly: 8206,
  report_used_dashboards: 9134,
  report_used_company_reports: 9135,
  dashboards_no_message: 9143,
  company_reports_no_message: 9151,
  disabled_user_selected: 9939,
  disabled_warning: 9178,
  disabled_warning_disabled_folder: 9180,
  disabled_folder_selected: 9179,
  favourites_updated: 9159,
  shared_with_warning: 9164,
  folder_wrong_owner_warning: 9206,
  invalid_owner_warning: 9207,

  // form header
  update_button: 9131,
  created: 9136,
  modified: 9137,
  by: 9152,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  dashboards_title: 9140,
  dashboards_description: 9162,
  company_reports_title: 9141,
  company_reports_description: 9161,
  shared_with: 9153,
  schedule: 9144,
  recipients: 9150,
  recipients_title: 9148,
  recipients_placeholder: 9149,

  // language
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,
  descriptions_and_translations: 8391,
  long_description: 9211,
  copy_long_description_to_all: 9212,
  copied_long_description_to_all: 9213,

  // manage options
  manage_options: 8521,

  // validation
  must_be_filled_out: 5949,
  must_be_within_range: 7939,
  at_least_one_must_be_filled_out: 9053,

  // form
  show_details: 7640,
  hide_details: 7641,
  favourite_type: 9139,
  remove_schedule: 6760,
  remove_schedule_description: 9142,
  invalid_email_error: 4710,
  shared_with_user_groups: 9146,
  shared_with_user_groups_info: 9173,
  add_user_groups: 9171,
  replace_existing_user_groups: 9172,
  shared_with_users: 9147,
  add_users: 9191,
  replace_existing_users: 9192,
  shared_with_users_info: 9193,
  regenerate_aggregated_tables: 9428,

  // filters
  filters: 7556,
  required: 9054,
  no_default_value: 8847,
  use_default_value: 8848,
  filters_not_supported: 8834,

  // predefined filters
  disabled_owners: 9113,
  used_in_dashboard: 9114,
  used_in_company_report: 9115,
  shared_reports: 9116,
  mismatched_owners: 9235,

  // filter labels
  parent: 9132,
  owner: 9094,
  owner_include_disabled: 9197,
  shared_user_group: 9095,
  shared_user: 9096,
  type_of_report: 9097,
  code: 9201,
  created_date: 9202,
  modiefied_date: 9203,
  report_type: 9204,
  scheduled_for_auto_execute: 6658,
  not_scheduled_for_auto_execute: 6659,
  remove: 7742,
  remove_all: 8435,
  done: 7338
};

export type FavouriteAdminTranslation = {
  readonly [T in keyof typeof favouriteAdminTranslation]: string
};
